export const bsearch = (val, arr) => {
  if (val > arr.at(-1)) return arr.length
  if (val <= arr[0]) return 0 
  let ub = arr.length, lb = 0, mid = Math.floor((ub+lb)/2)
  while (mid !== 0 && mid !== arr.length-1 && (arr[mid-1] > val || arr[mid] <= val)) { 
    if (arr[mid] <= val) lb = mid
    else ub = mid
    mid = Math.floor((ub+lb)/2)
  }
  return mid
}

const labelSDLevels = {
  batter_swing_pct: [
    [0.0, 61.3, 63.54, 66.94, 70.64, 70.92, 71.2, 72.88, 78.06, 83.18, 86.73, 88.2],
    [0.0, 61.3, 63.54, 66.94, 70.64, 70.92, 71.2, 72.88, 78.06, 83.18, 86.73, 88.2],
    [0.0, 61.3, 63.54, 66.94, 70.64, 70.92, 71.2, 72.88, 78.06, 83.18, 86.73, 88.2],
    [0.0, 61.3, 63.54, 66.94, 70.64, 70.92, 71.2, 72.88, 78.06, 83.18, 86.73, 88.2],
    [0.0, 61.3, 63.54, 66.94, 70.64, 70.92, 71.2, 72.88, 78.06, 83.18, 86.73, 88.2],
    [0.0, 61.3, 63.54, 66.94, 70.64, 70.92, 71.2, 72.88, 78.06, 83.18, 86.73, 88.2],
    [0.0, 61.3, 63.54, 66.94, 70.64, 70.92, 71.2, 72.88, 78.06, 83.18, 86.73, 88.2],
    [0.0, 61.3, 63.54, 66.94, 70.64, 70.92, 71.2, 72.88, 78.06, 83.18, 86.73, 88.2],
    [0.0, 61.3, 63.54, 66.94, 70.64, 70.92, 71.2, 72.88, 78.06, 83.18, 86.73, 88.2],
    [0.0, 2.0, 13.24, 17.1, 20.0, 22.84, 25.5, 28.66, 32.28, 36.4, 43.45, 67.6],
    [0.0, 2.0, 13.24, 17.1, 20.0, 22.84, 25.5, 28.66, 32.28, 36.4, 43.45, 67.6],
    [0.0, 2.0, 13.24, 17.1, 20.0, 22.84, 25.5, 28.66, 32.28, 36.4, 43.45, 67.6],
    [0.0, 2.0, 13.24, 17.1, 20.0, 22.84, 25.5, 28.66, 32.28, 36.4, 43.45, 67.6],
  ],

  batter_avg: [
    [0.0000, 0.182, 0.2586, 0.333, 0.364, 0.4, 0.4034, 0.4278, 0.5, 0.545],
    [0.0000, 0.182, 0.2586, 0.333, 0.364, 0.4, 0.4034, 0.4278, 0.5, 0.545],
    [0.0000, 0.182, 0.2586, 0.333, 0.364, 0.4, 0.4034, 0.4278, 0.5, 0.545],
    [0.0000, 0.182, 0.2586, 0.333, 0.364, 0.4, 0.4034, 0.4278, 0.5, 0.545],
    [0.0000, 0.182, 0.2586, 0.333, 0.364, 0.4, 0.4034, 0.4278, 0.5, 0.545],
    [0.0000, 0.182, 0.2586, 0.333, 0.364, 0.4, 0.4034, 0.4278, 0.5, 0.545],
    [0.0000, 0.182, 0.2586, 0.333, 0.364, 0.4, 0.4034, 0.4278, 0.5, 0.545],
    [0.0000, 0.182, 0.2586, 0.333, 0.364, 0.4, 0.4034, 0.4278, 0.5, 0.545],
    [0.0000, 0.182, 0.2586, 0.333, 0.364, 0.4, 0.4034, 0.4278, 0.5, 0.545],
    [0.0000 , 0.0728, 0.125, 0.167, 0.2, 0.222, 0.25, 0.3, 0.333, 0.47],
    [0.0000 , 0.0728, 0.125, 0.167, 0.2, 0.222, 0.25, 0.3, 0.333, 0.47],
    [0.0000 , 0.0728, 0.125, 0.167, 0.2, 0.222, 0.25, 0.3, 0.333, 0.47],
    [0.0000 , 0.0728, 0.125, 0.167, 0.2, 0.222, 0.25, 0.3, 0.333, 0.47],
  ],
  pitcher_pitch_pct: [
    [0.0, 6.1, 9.39, 10.6, 11.9, 12.8, 13.4, 14.34, 15.6, 16.4, 17.9, 26.1],
    [0.0, 6.1, 9.39, 10.6, 11.9, 12.8, 13.4, 14.34, 15.6, 16.4, 17.9, 26.1],
    [0.0, 6.1, 9.39, 10.6, 11.9, 12.8, 13.4, 14.34, 15.6, 16.4, 17.9, 26.1],
    [0.0, 6.1, 9.39, 10.6, 11.9, 12.8, 13.4, 14.34, 15.6, 16.4, 17.9, 26.1],
    [0.0, 6.1, 9.39, 10.6, 11.9, 12.8, 13.4, 14.34, 15.6, 16.4, 17.9, 26.1],
    [0.0, 6.1, 9.39, 10.6, 11.9, 12.8, 13.4, 14.34, 15.6, 16.4, 17.9, 26.1],
    [0.0, 6.1, 9.39, 10.6, 11.9, 12.8, 13.4, 14.34, 15.6, 16.4, 17.9, 26.1],
    [0.0, 6.1, 9.39, 10.6, 11.9, 12.8, 13.4, 14.34, 15.6, 16.4, 17.9, 26.1],
    [0.0, 6.1, 9.39, 10.6, 11.9, 12.8, 13.4, 14.34, 15.6, 16.4, 17.9, 26.1],
    [0.0, 8.3, 16.97, 21.34, 24.5, 27.28, 29.7, 32.3, 35.2, 39.06, 43.1, 74.4],
    [0.0, 8.3, 16.97, 21.34, 24.5, 27.28, 29.7, 32.3, 35.2, 39.06, 43.1, 74.4],
    [0.0, 8.3, 16.97, 21.34, 24.5, 27.28, 29.7, 32.3, 35.2, 39.06, 43.1, 74.4],
    [0.0, 8.3, 16.97, 21.34, 24.5, 27.28, 29.7, 32.3, 35.2, 39.06, 43.1, 74.4],
  ],
}
const getZoneBackgroundColor = (title, value, zoneid) => {
  console.log(title, value, zoneid)
  if (value === 0) return 1
  return bsearch(value, labelSDLevels[title][zoneid])
}
const wrapZoneColorTagData = (title, zonedata) => {
  if (title === 'batter_avg') {
    let color_clsn = zonedata.map((v, i) => (`zone_color_${getZoneBackgroundColor(title, parseFloat(v), i)}`))
    return color_clsn

  } else if (title === 'batter_swing_pct') {
    let color_clsn = zonedata.map((v, i) => (`zone_level_${getZoneBackgroundColor(title, parseFloat(v), i)}`))
    return color_clsn
  } else {
    let color_clsn = zonedata.map((v, i) => (`zone_level_${getZoneBackgroundColor(title, parseFloat(v), i)}`))
    return color_clsn
  }
}

export const wrapZoneGraphData = (type, data) => {
  let pr = wrapZoneColorTagData(type, data)
  return {
    ozone: data.slice(9, 13),
    ozonePR: pr.slice(9, 13),
    zone: data.slice(0, 9),
    zonePR: pr.slice(0, 9)
  }
}

